var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('v-btn',{attrs:{"loading":_vm.loading,"icon":"","small":"","color":"error"},on:{"click":function($event){return _vm.handleSubmit()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-delete")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }